import {mapGetters, mapActions} from 'vuex';
import {assign} from "lodash";

export default {
  name: 'ordersAwaiting',
  data() {
    return {}
  },
  components: {},
  created() {
    if (!('page' in this.$route.query)) {
      this.setUrlParams({page: 1});
    } else {
      this.fetchAwaitingOrders(this.$route.query);
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      ordersAwaitingList: 'orders/ordersAwaitingList',
      isOrdersAwaitingLoading: 'orders/isOrdersAwaitingLoading',
      ordersAwaitingPage: 'orders/ordersAwaitingPage',
      ordersAwaitingPageLength: 'orders/ordersAwaitingPageLength',
    }),
  },
  watch: {
    '$route.query': {
      handler: function (val) {
        if (val.page) {
          this.fetchAwaitingOrders(this.$route.query);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchAwaitingOrders: 'orders/ORDERS_REQUEST_AWAITING_LIST_GET',
    }),

    getClient(item) {
      return item.address
    },
    isAvailability(item) {
      return item.products.data.every(item => {
        let count = item.on_store_count - item.order_count;
        return count >= 0;
      })
    },
    setUrlParams(query = {}) {
      this.$router.push({name: 'orders.list', query: assign({}, this.$route.query, query)}).catch(() => {
        console.log()
      });
    },

    getPage(pageId) {
      this.setUrlParams({page: pageId})
    },
    show(order) {
      this.$router.push({name: 'orders.show', params: {orderId: order.id}}).catch(() => {console.log();});
    }
  },
  destroyed() {},
}
